export function retrievedQuestions(){
    return(localStorage.getItem("hanami") === null ? null : localStorage.getItem("hanami").split(','))
}

export function addQuestionToLocalStorage(id){
    let ids = localStorage.getItem("hanami");
    if(ids === null){
        localStorage.setItem("hanami", id);
    } else if(!ids.includes(id)){
        localStorage.setItem("hanami", ids+','+id);
    } else {
        let arr = ids.split(',');
        const index = arr.indexOf(id.toString());
        if (index > -1) {
          arr.splice(index, 1);
        }
        localStorage.setItem("hanami", arr.join(','));
    }
}